import storeModule from './store-module'
import { defineStore } from 'pinia'

export default defineStore('document-types', storeModule.createStoreModule('document-types'))
